/* eslint-disable simple-import-sort/imports */
/* eslint-disable curly */
// This code is generated automatically. Do not modify it manually.
// The suppressions below are required to suppress false positive ESLint warnings.
//
// Generated: Mon, 24 Nov 2025 17:04:18 GMT
//
// noinspection RedundantIfStatementJS, JSUnusedGlobalSymbols, DuplicatedCode
//
import { City, Country, CountryType, State } from '@/types/country';
import { isArray, isString } from '@/types/common-type-guards';

const valuesOfCountryType: readonly string[] = [
  'AX',
  'DZ',
  'AS',
  'AD',
  'AO',
  'AI',
  'AQ',
  'AG',
  'AR',
  'AM',
  'AW',
  'AU',
  'AT',
  'AZ',
  'BH',
  'BD',
  'BB',
  'BE',
  'BZ',
  'BJ',
  'BM',
  'BT',
  'BO',
  'BQ',
  'BA',
  'BW',
  'BV',
  'BR',
  'IO',
  'BN',
  'BG',
  'BF',
  'BI',
  'KH',
  'CM',
  'CA',
  'CV',
  'KY',
  'TD',
  'CL',
  'CN',
  'CX',
  'CC',
  'CO',
  'KM',
  'CK',
  'CR',
  'CI',
  'HR',
  'CW',
  'CY',
  'CZ',
  'CD',
  'DK',
  'DJ',
  'DM',
  'DO',
  'EC',
  'EG',
  'SV',
  'GQ',
  'ER',
  'EE',
  'SZ',
  'FK',
  'FO',
  'FJ',
  'FI',
  'FR',
  'GF',
  'PF',
  'TF',
  'GA',
  'GE',
  'DE',
  'GH',
  'GI',
  'GR',
  'GL',
  'GD',
  'GP',
  'GU',
  'GT',
  'GG',
  'GN',
  'GW',
  'GY',
  'HT',
  'HM',
  'HN',
  'HK',
  'HU',
  'IS',
  'IN',
  'ID',
  'IQ',
  'IE',
  'IL',
  'IT',
  'JM',
  'JP',
  'JE',
  'JO',
  'KZ',
  'KE',
  'KI',
  'KW',
  'KG',
  'LA',
  'LV',
  'LS',
  'LR',
  'LI',
  'LT',
  'LU',
  'MO',
  'MG',
  'MW',
  'MY',
  'MV',
  'MT',
  'IM',
  'MH',
  'MQ',
  'MR',
  'MU',
  'YT',
  'MX',
  'FM',
  'MD',
  'MC',
  'MN',
  'ME',
  'MS',
  'MA',
  'MZ',
  'NA',
  'NR',
  'NP',
  'NL',
  'NC',
  'NZ',
  'NE',
  'NG',
  'NU',
  'NF',
  'MP',
  'NO',
  'OM',
  'PK',
  'PW',
  'PS',
  'PA',
  'PG',
  'PY',
  'PE',
  'PH',
  'PN',
  'PL',
  'PT',
  'PR',
  'QA',
  'RE',
  'RU',
  'RW',
  'SH',
  'KN',
  'LC',
  'PM',
  'VC',
  'BL',
  'MF',
  'WS',
  'SM',
  'ST',
  'SA',
  'SN',
  'SC',
  'SL',
  'SG',
  'SX',
  'SK',
  'SI',
  'SB',
  'SO',
  'ZA',
  'GS',
  'KR',
  'ES',
  'LK',
  'SR',
  'SJ',
  'SE',
  'CH',
  'TW',
  'TJ',
  'TZ',
  'TH',
  'BS',
  'GM',
  'TL',
  'TG',
  'TK',
  'TO',
  'TT',
  'TN',
  'TR',
  'TM',
  'TC',
  'TV',
  'UG',
  'AE',
  'GB',
  'US',
  'UM',
  'UY',
  'UZ',
  'VU',
  'VA',
  'VN',
  'VG',
  'VI',
  'WF',
  'EH',
  'ZM',
  'ZW',
  '',
];

export const isCountryType = (value: unknown): value is CountryType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfCountryType.includes(value);
};

export const isCountryTypeOrNull = (value: unknown): value is CountryType | null => {
  return value === null || isCountryType(value);
};

export const isArrayOfCountryType = (value: unknown): value is CountryType[] => {
  return Array.isArray(value) && value.every(isCountryType);
};

export const isArrayOfCountryTypeOrNull = (value: unknown): value is CountryType[] | null => {
  return value === null || isArrayOfCountryType(value);
};

export const isCity = (value: unknown): value is City => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('name' in value && isString(value.name))) return false;

  return true;
};

export const isCityOrNull = (value: unknown): value is City | null => {
  return value === null || isCity(value);
};

export const isArrayOfCity = (value: unknown): value is readonly City[] => {
  return Array.isArray(value) && value.every(isCity);
};

export const isArrayOfCityOrNull = (value: unknown): value is readonly City[] | null => {
  return value === null || isArrayOfCity(value);
};

const propertiesOfCity: readonly string[] = ['id', 'name'];

export const isKeyOfCity = (value: unknown): value is keyof City => {
  return typeof value === 'string' && propertiesOfCity.includes(value);
};

export const isState = (value: unknown): value is State => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('cities' in value && isArray(value.cities))) return false;

  return true;
};

export const isStateOrNull = (value: unknown): value is State | null => {
  return value === null || isState(value);
};

export const isArrayOfState = (value: unknown): value is readonly State[] => {
  return Array.isArray(value) && value.every(isState);
};

export const isArrayOfStateOrNull = (value: unknown): value is readonly State[] | null => {
  return value === null || isArrayOfState(value);
};

const propertiesOfState: readonly string[] = ['id', 'name', 'cities'];

export const isKeyOfState = (value: unknown): value is keyof State => {
  return typeof value === 'string' && propertiesOfState.includes(value);
};

export const isCountry = (value: unknown): value is Country => {
  if (value === null || typeof value !== 'object') return false;
  if (!('id' in value && isString(value.id))) return false;
  if (!('name' in value && isString(value.name))) return false;
  if (!('currency' in value && isString(value.currency))) return false;
  if (!('states' in value && isArrayOfState(value.states))) return false;

  return true;
};

export const isCountryOrNull = (value: unknown): value is Country | null => {
  return value === null || isCountry(value);
};

export const isArrayOfCountry = (value: unknown): value is readonly Country[] => {
  return Array.isArray(value) && value.every(isCountry);
};

export const isArrayOfCountryOrNull = (value: unknown): value is readonly Country[] | null => {
  return value === null || isArrayOfCountry(value);
};

const propertiesOfCountry: readonly string[] = ['id', 'name', 'currency', 'states'];

export const isKeyOfCountry = (value: unknown): value is keyof Country => {
  return typeof value === 'string' && propertiesOfCountry.includes(value);
};
